import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from 'src/app/digigov/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  static countVal = 0;
  constructor(private http: HttpClient) {}
  getIntimationCount(): void {
    const params = new HttpParams()
      .append('docTypeIds', '9')
      .append('container', 'Inbox')
      .append('newFlag', 1);
    this.http
      .get('/worklist/intimation-count', {
        params: params,
      })
      .subscribe(
        (response: Response<any>) => {
          HeaderService.countVal = response.data;
        },
        (err) => {
          console.log(err);
        }
      );
  }
  getCount() {
    if (HeaderService.countVal > 999 && HeaderService.countVal < 2999) {
      return '1k+';
    } else if (HeaderService.countVal > 1999 && HeaderService.countVal < 2999) {
      return '2k+';
    } else if (HeaderService.countVal > 2999 && HeaderService.countVal < 3999) {
      return '3k+';
    } else if (HeaderService.countVal > 3999 && HeaderService.countVal < 4999) {
      return '4k+';
    } else if (HeaderService.countVal > 4999 && HeaderService.countVal < 5999) {
      return '5k+';
    } else {
      return HeaderService.countVal;
    }
  }
}
